import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';

interface IChoice {
  /** Value of the choice */
  value: string;
  /** Label for the choice */
  label: string | Component;
  /** Disable choice */
  disabled?: boolean;
  /** Additional text to aide in use */
  helpText?: string | Component;
  /** Indicates that the choice is aria-describedBy the error message*/
  describedByError?: boolean;
}

interface IArgs {
  /** Label for list of choices */
  title: string | Component;
  /** Collection of choices */
  choices?: IChoice[];
  /** Collection of selected choices */
  selected: string[];
  /** Name for form input */
  name?: string;
  /** Allow merchants to select multiple options at once */
  allowMultiple?: boolean;
  /** Toggles display of the title */
  titleHidden?: boolean;
  /** Display an error message */
  error?: Error;
  /** Disable all choices **/
  disabled?: boolean;
  /** Callback when the selected choices change */
  onChange?(selected: string[], name: string): void;
}

export default class BvChoiceList extends Component<IArgs> {
  name = `${guidFor(this)}BvChoiceList`;

  @action
  handleChange(choice: IChoice, checked: boolean) {
    const { selected, allowMultiple } = this.args;
    return this.args.onChange?.(
      updateSelectedChoices(choice, checked, selected, allowMultiple),
      this.name
    );
  }
}

function updateSelectedChoices(
  { value }: IChoice,
  checked: boolean,
  selected: string[],
  allowMultiple: boolean = false
) {
  if (checked) {
    return allowMultiple ? [...selected, value] : [value];
  }

  return selected.filter((selectedChoice) => selectedChoice !== value);
}
